export enum errorCodeConstants {
  DATA_NOT_FOUND = '101',
  CONTENT_NOT_AVAILABLE_IN_YOUR_REGION = '607'
}
